import React from "react";
import "../../Styles/yellowcalf.css/Failed_Payments.css";

function Failed_Payments() {
  return (
    <div className="failed-payments-container my-2" >
      {/* PANEL: Title */}
      <div className="failed-payments-row">
        <div className="failed-payments-col">
          <div className="failed-payments-panel">
            <div className="failed-payments-panel-body">
              <div className="failed-payments-header">
                <h3 className="failed-payments-title">Failed Payments</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inv-filters d-flex flex-wrap gap-3">
        <input
          type="text"
          className="inv-input"
          placeholder="Search Invoice No."
        />

        <input
          type="text"
          className="inv-input"
          placeholder="Search Date"
        />
        <button
          type="reset"
          className="failed-payments-clear-btn"
        >
          Clear
        </button>
      </div>

      {/* PANEL: Table */}
      <div className="failed-payments-row">
        <div className="failed-payments-col">
          <div className="failed-payments-panel">
            <div className="failed-payments-panel-body">
              <div className="failed-payments-table-wrapper">
                <div className="failed-payments-grid">
                  <table className="failed-payments-table">
                    <thead>

                      <tr>
                        <th style={{textAlign:'center'}}>Sr .No</th>
                        <th style={{textAlign:'center'}}>Invoice Number</th>
                        <th style={{textAlign:'center'}}>Payment Type</th>
                        <th style={{textAlign:'center'}}>Payment Mode</th>
                        <th style={{textAlign:'center'}}>Payment Identification Number</th>
                        <th style={{textAlign:'center'}}>Amount</th>
                        <th style={{textAlign:'center'}}>Payment Date</th>
                        <th style={{textAlign:'center'}}>Invoice Date</th>
                        <th style={{textAlign:'center'}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{textAlign:'center'}}>1</td>
                        <td style={{textAlign:'center'}}>877</td>
                        <td style={{textAlign:'center'}}>Service</td>
                        <td style={{textAlign:'center'}}>Paytm</td>
                        <td style={{textAlign:'center'}}>877_73554</td>
                        <td style={{textAlign:'center'}}>$ 2700</td>
                        <td style={{textAlign:'center'}}>Wed Apr 20 2022</td>
                        <td style={{textAlign:'center'}}>Mon Jul 27 2020</td>
                        <td className="failed-payments-actions">
                          <a
                            className="failed-payments-view-btn"
                            href="/accountant/failedtransaction/Payment Details"
                            title="View Receipt"
                          >
                            <i class="bi bi-eye"></i>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style={{textAlign:'center'}}>2</td>
                        <td style={{textAlign:'center'}}>877</td>
                        <td style={{textAlign:'center'}}>Service</td>
                        <td style={{textAlign:'center'}}>Paytm</td>
                        <td style={{textAlign:'center'}}>877_10791</td>
                        <td style={{textAlign:'center'}}>$ 2700</td>
                        <td style={{textAlign:'center'}}>Wed Apr 20 2022</td>
                        <td style={{textAlign:'center'}}>Mon Jul 27 2020</td>
                        <td className="failed-payments-actions">
                          <a
                            className="failed-payments-view-btn"
                            href="/accountant/failedtransaction/Payment Details"
                            title="View Receipt"
                          >
                            <i class="bi bi-eye"></i>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style={{textAlign:'center'}}>2</td>
                        <td style={{textAlign:'center'}}>877</td>
                        <td style={{textAlign:'center'}}>Service</td>
                        <td style={{textAlign:'center'}}>Paytm</td>
                        <td style={{textAlign:'center'}}>877_10791</td>
                        <td style={{textAlign:'center'}}>$ 2700</td>
                        <td style={{textAlign:'center'}}>Wed Apr 20 2022</td>
                        <td style={{textAlign:'center'}}>Mon Jul 27 2020</td>
                        <td className="failed-payments-actions">
                          <a
                            className="failed-payments-view-btn"
                            href="/accountant/failedtransaction/Payment Details"
                            title="View Receipt"
                          >
                            <i class="bi bi-eye"></i>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style={{textAlign:'center'}}>2</td>
                        <td style={{textAlign:'center'}}>877</td>
                        <td style={{textAlign:'center'}}>Service</td>
                        <td style={{textAlign:'center'}}>Paytm</td>
                        <td style={{textAlign:'center'}}>877_10791</td>
                        <td style={{textAlign:'center'}}>$ 2700</td>
                        <td style={{textAlign:'center'}}>Wed Apr 20 2022</td>
                        <td style={{textAlign:'center'}}>Mon Jul 27 2020</td>
                        <td className="failed-payments-actions">
                          <a
                            className="failed-payments-view-btn"
                            href="/accountant/failedtransaction/Payment Details"
                            title="View Receipt"
                          >
                            <i class="bi bi-eye"></i>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style={{textAlign:'center'}}>2</td>
                        <td style={{textAlign:'center'}}>877</td>
                        <td style={{textAlign:'center'}}>Service</td>
                        <td style={{textAlign:'center'}}>Paytm</td>
                        <td style={{textAlign:'center'}}>877_10791</td>
                        <td style={{textAlign:'center'}}>$ 2700</td>
                        <td style={{textAlign:'center'}}>Wed Apr 20 2022</td>
                        <td style={{textAlign:'center'}}>Mon Jul 27 2020</td>
                        <td className="failed-payments-actions">
                          <a
                            className="failed-payments-view-btn"
                            href="/accountant/failedtransaction/Payment Details"
                            title="View Receipt"
                          >
                            <i class="bi bi-eye"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="wallet-main-footer">
                    <ul className="wallet-main-pagination">
                      <li className="wallet-main-active">
                        <a href="#">1</a>
                      </li>
                      <li>
                        <a href="#">2</a>
                      </li>
                      <li>
                        <a href="#">3</a>
                      </li>
                    </ul>

                    <div className="wallet-main-summary">
                      Showing <b>1-50</b> of <b>177</b> items.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Failed_Payments;
